import { MULTIPATH_MODE_TRAIN, PROVIDER_TRAIN } from '../../../store/itinerary/itinerary.constants'
import { decorateRouteWithId } from '../../../store/itinerary/itinerary.dataParser'
import { selectProviders } from '../../../store/itinerary/itinerary.selectors'
import { selectRoutes } from '../../../store/itinerary/routes.selectors'
import { formatRoute } from '../../../store/itinerary/routes.utils'
import { createCustomSelector } from '../../utils/react-reselect'

export const selectFakeTrainRoute = createCustomSelector(selectProviders, selectRoutes, (providers, routes) => {
  const hasTrain = Boolean((providers ?? []).find(({ name }) => name === PROVIDER_TRAIN))
  const hasTrainRoutes = Boolean(routes.find(({ provider: { id } }) => id === PROVIDER_TRAIN))
  if (hasTrain && !hasTrainRoutes)
    return formatRoute(
      decorateRouteWithId({
        provider: {
          id: PROVIDER_TRAIN
        },
        icon: 'train',
        fakeTrainRoute: true,
        mode: MULTIPATH_MODE_TRAIN
      })
    )
})
